import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import A from '../../../../common/A';
import { TYPE, URL } from '../../../../../constant';
import { useLearningData, useUserInfo } from '../../../../../hooks';
import { learningHistoryListAPI } from '../../../../../api/learningNote';
import { pagingRowNum } from '../../../../../utils/utilityEtc';

function ResultIcon({ code }) {
  let cs = "";
  const { i18n } = useTranslation()

  switch (code.lrnPrgsStsCd) {
    case 'LPSC01': cs = ''; break;
    case 'LPSC02': cs = 'yellow'; break;
    case 'LPSC03': cs = 'green'; break;
    case 'LPSC04': cs = 'purple'; break;
    default: break;
  }
  return (
    <div className={clsx("ico_area", cs)}>
      <span>{i18n.language === 'ko' && code.cdNm}</span>
    </div>
  )
}

function LearningTab({tab}) {
  localStorage.setItem("learning.id", TYPE.LEARNING.TOPIC);
  const history = useHistory();
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const [context, setContext] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [list, setList] = useState(null);
  // const [
  //   learningHistoryListCall,
  //   list,
  // ] = useRequest((data) => learningHistoryListAPI(data), true);
  const [page, setPage] = useState(1);
  const { setLearningData } = useLearningData();

  useEffect(() => {
    // 탭 이동시 페이지 데이터 초기화
    setPageCnt(1);
    setPage(1);
  }, [tab])

  const learningHistoryListFunc = useCallback(async (currentPage) => {
    const { channelCode, learnerId, locale } = info;
    
    const resp = await learningHistoryListAPI({
      channel: channelCode,
      language: locale,
      learner: learnerId,
      entyPathCd: tab === 'ocr' ? 'OCR' : '',
      currentPage,
    })
    if (resp?.code === 'S000000') {
      setList(resp.resp);
    };
  }, [tab])

  useEffect(() => {
    if (!info.channelCode) return;
    if (tab) {
      setList(null);
      setContext([])
    }
    learningHistoryListFunc();
  }, [learningHistoryListFunc, tab]);

  useEffect(() => {
    if (!list || !list.noteStgListByThmaList) return;
    
    setContext((old) => ([
      ...old,
      ...list.noteStgListByThmaList
    ]))

    const cnt = Math.ceil(list.totalCnt / (1 * 10));
    setPageCnt(cnt > 1 ? cnt : 0);
  }, [list]);

  const handleAdd = () => {
    if (!list) return;
    if (page <= pageCnt) {
      setPage((page + 1));
      learningHistoryListFunc(page + 1);
    }
  };

  const handleClick = (item) => {
    setLearningData({ stgCd: item.stgCd, prevPage: "learningNote" });

    history.push({
      pathname: `${URL.LEARNING.RESULT}`,
      state: {
        stgCd: item.stgCd
      }
    });
  };
  
  return (
    <div className="progress_list">
      {
        (context && context.length === 0) && (
          <div className={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'empty' : 'yet'}>
            <span>{t("LC_03_05_01.msg009")}</span>
          </div>
        )
      }
      {
        (context && context.length > 0) && (
          context.map((item, index) => (
            <article key={index}>
              <div className="upper cls">
                {
                  info.channelCode === TYPE.CHANNEL.GLOBAL01 && (
                    <div className="num">
                      {pagingRowNum(list.totalCnt, context.length, pageCnt-1, index)}
                    </div>
                  )
                }
                <div className="tit">{item.stgNm}</div>
                <div className="state">
                  {
                    item.noteEndDtListByStg.map((state, index) => (
                      <div key={index} className="line cls">
                        <div className="date">
                          {moment(state.lrnEndDt).format('YYYY.MM.DD')}
                        </div>
                        <ResultIcon code={state} />
                      </div>
                    ))
                  }
                </div>
                <div className="btn_area">
                  <A className="result_btn" onClick={() => handleClick(item)}>
                    {t('LC_03_05-GM.msg009')}
                  </A>
                </div>
              </div>
              <div className="tags cls">
                {
                  item.entyPathCdList && item.entyPathCdList.map((enty, index) => (
                    <button key={index} type="button">{enty.entyPathCdNm}</button>
                  ))
                }
              </div>
            </article>
          ))
        )
      }
      {
        (list && (pageCnt > page)) && (
          <div className="more">
            <button
              className="button"
              onClick={handleAdd}
            >
              {t('LC_03_05-GM.msg012')} +
            </button>
          </div>
        )
      }
    </div>
  );
}

export default LearningTab;
